import { render, staticRenderFns } from "./QuestionValueAdd.vue?vue&type=template&id=8d6b7be2&"
import script from "./QuestionValueAdd.vue?vue&type=script&lang=ts&"
export * from "./QuestionValueAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d6b7be2')) {
      api.createRecord('8d6b7be2', component.options)
    } else {
      api.reload('8d6b7be2', component.options)
    }
    module.hot.accept("./QuestionValueAdd.vue?vue&type=template&id=8d6b7be2&", function () {
      api.rerender('8d6b7be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/questions/questionValue/QuestionValueAdd.vue"
export default component.exports